var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 21.45C12.7166 21.2834 12.6458 21.1 12.6375 20.9C12.6291 20.7 12.7 20.525 12.85 20.375L17.25 15.975L12.825 11.55C12.6916 11.4167 12.6291 11.2375 12.6375 11.0125C12.6458 10.7875 12.7166 10.6084 12.85 10.475C13.0166 10.3084 13.1958 10.2292 13.3875 10.2375C13.5791 10.2459 13.75 10.325 13.9 10.475L18.875 15.45C18.9583 15.5334 19.0166 15.6167 19.05 15.7C19.0833 15.7834 19.1 15.875 19.1 15.975C19.1 16.075 19.0833 16.1667 19.05 16.25C19.0166 16.3334 18.9583 16.4167 18.875 16.5L13.925 21.45C13.775 21.6 13.6 21.6709 13.4 21.6625C13.2 21.6542 13.0166 21.5834 12.85 21.45Z",
    fill: "#1E2329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollRight);
export default __webpack_public_path__ + "static/media/scroll-right.bd87d766.svg";
export { ForwardRef as ReactComponent };